// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"a1e22d6e","453":"0961dd42"}[chunkId] + ".chunk.js";
};